import { getRandomInt } from '~/bootcamp/Activities/Fractions/Fractions.utils'

import { BlockContentWrapper } from '~/bootcamp/Activities/types/activities.types'

import { CategorizationActivityData, Column, Task, TaskStatus, CategorizationQuestion } from './Categorization.type'

let defaultCols: Column[] = []

let defaultTasks: Task[] = []

function SortBlockData(item: BlockContentWrapper, id: number): Task {
  const data = {
    id,
    columnId: 'questions',
    category: '',
    content: {},
    check: false,
    taskStatus: TaskStatus.Unchecked,
  }

  data.content = item.element

  return data
}

function getColumnsData(): Column[] {
  return defaultCols
}
function getTasksData(): Task[] {
  return defaultTasks
}

/** Span text plus latex bodies as plain text; image-only content returns ''. */
function taskCardText(blocks: unknown): string {
  if (!Array.isArray(blocks)) return ''
  return blocks
    .map((block) => {
      if (!block || typeof block !== 'object') return ''
      const part = block as { _type?: string; body?: string; text?: string; children?: unknown[] }
      if (part._type === 'latex') return part.body ?? ''
      if (Array.isArray(part.children)) return taskCardText(part.children)
      return part.text ?? ''
    })
    .join(' ')
    .replace(/\s+/g, ' ')
    .trim()
}

function sortData(data: CategorizationQuestion): void {
  defaultCols = [
    {
      id: 'category1',
      categoryName: data.category1Title,
    },
    {
      id: 'category2',
      categoryName: data.category2Title,
    },
  ]

  let uniqueId = 1

  let unshuffled = data.elementsCategory1.map((el) => {
    const item = SortBlockData(el, uniqueId)
    uniqueId++
    item.category = 'category1'
    return item
  })

  unshuffled = unshuffled.concat(
    data.elementsCategory2.map((el) => {
      const item = SortBlockData(el, uniqueId)
      uniqueId++
      item.category = 'category2'
      return item
    }),
  )

  // eslint-disable-next-line fp/no-mutating-methods
  defaultTasks = unshuffled
    .map((value: Task) => ({ value, sort: Math.random() }))
    .sort((a: { sort: number }, b: { sort: number }) => a.sort - b.sort)
    .map(({ value }: { value: Task }) => value)
}
function generateCategorizationActivityData(
  questions: CategorizationQuestion[],
  history: number[],
): CategorizationActivityData {
  const questionIndex = getRandomInt(0, questions.length - 1, history)
  const question = questions[questionIndex]

  return { question, questionIndex }
}

export { getColumnsData, getTasksData, sortData, taskCardText, generateCategorizationActivityData }
